import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';

interface ZoneNodeProps {
  data: {
    label: string;
    description?: string;
  };
}

function ZoneNode({ data }: ZoneNodeProps) {
  return (
    <div className="px-4 py-2 shadow-md rounded-md border-2 bg-white border-stone-400">
      <div className="flex">
        <div className="ml-2">
          <div className="text-lg font-bold text-gray-700">{data.label}</div>
          {data.description && <div className="text-gray-500">{data.description}</div>}
        </div>
      </div>

      <Handle type="target" position={Position.Top} className="w-16 !bg-teal-500" />
      <Handle type="source" position={Position.Bottom} className="w-16 !bg-teal-500" />
    </div>
  );
}

export default memo(ZoneNode);
